import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functionsAsaas, getHttpFunctionUrl, postJsonWithAuth } from '../firebase';
import ModalReautenticacao from './ModalReautenticacao';
import BarraFiltros, { BotaoConsultar } from './BarraFiltros';

const situacoes = { PENDING: 'Pendente', OVERDUE: 'Vencida', RECEIVED: 'Paga', CONFIRMED: 'Confirmada', RECEIVED_IN_CASH: 'Paga em dinheiro', REFUNDED: 'Estornada', CANCELLED: 'Cancelada' };
const consultarFaturas = (data) => httpsCallable(functionsAsaas, 'gerenciarFaturasCliente')(data);
const planos = { gratuito: 'Gratuito', bronze: 'Bronze', prata: 'Prata', ouro: 'Ouro', diamante: 'Diamante' };
const assinaturas = {
  ativa: 'Ativa', inativa: 'Inativa', aguardando_pagamento: 'Aguardando pagamento',
  cancelada: 'Cancelada', cancelada_agendada: 'Cancelamento agendado',
};
function formatarRotulo(valor, rotulos, padrao) {
  const chave = String(valor || '').trim().toLowerCase();
  if (!chave) return padrao;
  const texto = chave.replace(/[_-]+/g, ' ');
  return rotulos[chave] || texto.charAt(0).toUpperCase() + texto.slice(1);
}

export default function AbaClientes() {
  const [busca, setBusca] = useState('');
  const [tipo, setTipo] = useState('email');
  const [filtro, setFiltro] = useState({ termo: '', tipo: 'email' });
  const [cursores, setCursores] = useState(['']);
  const [pagina, setPagina] = useState(0);
  const [clientes, setClientes] = useState([]);
  const [proximo, setProximo] = useState('');
  const [cliente, setCliente] = useState(null);
  const [paginaFaturas, setPaginaFaturas] = useState(0);
  const [dados, setDados] = useState({ faturas: [] });
  const [carregando, setCarregando] = useState(false);
  const [carregandoFaturas, setCarregandoFaturas] = useState(false);
  const [erro, setErro] = useState('');
  const [confirmando, setConfirmando] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [atualizacao, setAtualizacao] = useState(0);
  const [mostrarHistorico, setMostrarHistorico] = useState(false);

  useEffect(() => {
    let vigente = true;
    setCarregando(true);
    setErro('');
    (async () => {
      try {
        const resposta = await postJsonWithAuth(getHttpFunctionUrl('gerenciarUsuariosPainel'), {
          action: 'list_clients', searchType: filtro.tipo, searchTerm: filtro.termo,
          cursorDocId: cursores[pagina], pageSize: 20,
        });
        const result = await resposta.json();
        if (!resposta.ok || !result.sucesso) throw new Error(result.erro || 'Falha ao consultar clientes.');
        if (vigente) { setClientes(result.users || []); setProximo(result.nextCursorDocId || ''); }
      } catch (e) { if (vigente) { setClientes([]); setProximo(''); setErro(e.message); } }
      finally { if (vigente) setCarregando(false); }
    })();
    return () => { vigente = false; };
  }, [filtro, cursores, pagina]);

  useEffect(() => {
    if (!cliente) return undefined;
    let vigente = true;
    setCarregandoFaturas(true);
    setDados({ faturas: [] });
    setErro('');
    consultarFaturas({ action: mostrarHistorico ? 'historico' : 'listar', userId: cliente.id, offset: paginaFaturas * 10 })
      .then((r) => { if (vigente) setDados(r.data); })
      .catch((e) => { if (vigente) setErro(e.message); })
      .finally(() => { if (vigente) setCarregandoFaturas(false); });
    return () => { vigente = false; };
  }, [cliente, paginaFaturas, atualizacao, mostrarHistorico]);

  async function cancelar() {
    setConfirmando(false);
    setCancelando(true);
    setErro('');
    try {
      await consultarFaturas({ action: 'cancelar', userId: cliente.id, assinatura: dados.assinatura });
      setClientes((lista) => lista.map((c) => c.id === cliente.id ? { ...c, plano: 'gratuito', status_assinatura: 'cancelada' } : c));
      alert('Contratação cancelada: recorrência e faturas em aberto encerradas. Cliente no Gratuito.');
    } catch (e) { setErro(e.message); }
    finally { setCancelando(false); setAtualizacao((v) => v + 1); }
  }

  const ocupado = carregandoFaturas || cancelando;
  return <section className="routine-panel">
    {erro && <div className="routine-callout routine-callout--warm" role="alert">{erro}</div>}
    {!cliente ? <>
      <BarraFiltros rotulo="Filtros de clientes" onSubmit={(e) => {
        e.preventDefault(); setCursores(['']); setPagina(0); setFiltro({ termo: busca.trim(), tipo });
      }} acoes={<>
        <BotaoConsultar disabled={carregando} />
        {(busca || filtro.termo) && <button type="button" className="routine-btn routine-btn--soft" disabled={carregando} onClick={() => {
          setBusca(''); setCursores(['']); setPagina(0); setFiltro({ termo: '', tipo });
        }}>Limpar</button>}
      </>}>
        <div className="routine-field">
        <label className="routine-label" htmlFor="clientes-filtro">Filtro</label>
        <select id="clientes-filtro" className="routine-select" aria-label="Buscar por" value={tipo} onChange={(e) => { setTipo(e.target.value); setBusca(''); }}>
          <option value="email">E-mail</option><option value="nome">Nome</option>
        </select>
        </div>
        <div className="routine-field routine-field--grow">
        <label className="routine-label" htmlFor="clientes-busca">Busca</label>
        <input id="clientes-busca" type="text" className="routine-input" aria-label="Busca de cliente" placeholder={tipo === 'email' ? 'Ex: joao@gmail.com' : 'Ex: João da Silva'} value={busca} onChange={(e) => setBusca(e.target.value)} />
        </div>
      </BarraFiltros>
      <div className="routine-table-wrap"><table className="routine-table">
        <thead><tr><th>Cliente</th><th>Plano</th><th>Assinatura</th><th>Ações</th></tr></thead>
        <tbody>{!carregando && clientes.map((c) => <tr key={c.id}>
          <td><div className="admin-user-card"><strong className="admin-user-card__name">{c.nome || 'Sem nome'}</strong><span className="admin-user-card__email">{c.email}</span></div></td><td>{formatarRotulo(c.plano, planos, 'Gratuito')}</td>
          <td>{formatarRotulo(c.status_assinatura, assinaturas, 'Sem assinatura')}</td>
          <td><button className="routine-btn routine-btn--soft" onClick={() => { setMostrarHistorico(false); setPaginaFaturas(0); setDados({ faturas: [] }); setCliente(c); }}>Ver faturas</button></td>
        </tr>)}</tbody>
      </table></div>
      {carregando ? <p>Carregando clientes...</p> : clientes.length === 0 && <p>Nenhum cliente encontrado.</p>}
      <div className="routine-actions">
        <button className="routine-btn routine-btn--soft" disabled={carregando || pagina === 0} onClick={() => setPagina(pagina - 1)}>Anterior</button>
        <span>Página {pagina + 1}</span>
        <button className="routine-btn routine-btn--soft" disabled={carregando || !proximo} onClick={() => {
          setCursores((c) => [...c.slice(0, pagina + 1), proximo]); setPagina(pagina + 1);
        }}>Próxima</button>
      </div>
    </> : <>
      <div className="routine-toolbar">
      <div className="routine-title-group">
        <h3 className="routine-section-title">Faturas de {cliente.nome || cliente.email}</h3>
        <p className="routine-section-subtitle">{cliente.email}</p>
      </div>
      <div className="routine-actions">
        <button className="routine-btn routine-btn--soft" disabled={cancelando} onClick={() => setCliente(null)}>Voltar aos clientes</button>
        <button className="routine-btn routine-btn--soft" disabled={ocupado} onClick={() => { setPaginaFaturas(0); setMostrarHistorico(v => !v); }}>{mostrarHistorico ? 'Consultar Asaas' : 'Histórico salvo'}</button>
        <button className="routine-btn routine-btn--soft" disabled={ocupado} onClick={() => setAtualizacao((v) => v + 1)}>Atualizar faturas</button>
      </div>
      </div>
      {dados.aviso && <p className="routine-callout routine-callout--warm" role="status">{dados.aviso}</p>}
      {dados.origemHistorico && <p className="routine-section-subtitle">Histórico salvo: a situação exibida é a última registrada, não uma confirmação atual do Asaas.</p>}
      <div className="routine-table-wrap"><table className="routine-table">
        <thead><tr><th>Descrição</th><th>Valor</th><th>Vencimento</th><th>Situação</th><th>Fatura</th></tr></thead>
        <tbody>{dados.faturas.map((f) => <tr key={f.id}>
          <td>{f.descricao || f.id}</td><td>{Number(f.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
          <td>{f.vencimento?.split('-').reverse().join('/')}</td><td>{situacoes[f.status] || f.status}</td>
          <td>{/^https:\/\//i.test(f.link) && f.status !== 'CANCELLED' && <a href={f.link} target="_blank" rel="noopener noreferrer">Abrir fatura</a>}</td>
        </tr>)}</tbody>
      </table></div>
      {carregandoFaturas ? <p>Consultando faturas...</p> : !erro && dados.faturas.length === 0 && <p>{dados.origemHistorico ? 'Nenhuma fatura salva nesta página.' : 'Nenhuma fatura nesta página.'}</p>}
      <div className="routine-actions">
        <button className="routine-btn routine-btn--soft" disabled={ocupado || paginaFaturas === 0} onClick={() => setPaginaFaturas(paginaFaturas - 1)}>Anterior</button>
        <span>Página {paginaFaturas + 1}</span>
        <button className="routine-btn routine-btn--soft" disabled={ocupado || !dados.temMais} onClick={() => setPaginaFaturas(paginaFaturas + 1)}>Próxima</button>
      </div>
      {dados.podeCancelar && <button className="routine-btn routine-btn--primary" disabled={ocupado} onClick={() => setConfirmando(true)}>
        {cancelando ? 'Cancelando...' : 'Cancelar contratação pendente'}
      </button>}
      <p className="routine-section-subtitle">O cancelamento encerra a recorrência e as faturas em aberto dessa contratação. Contratações já pagas não podem ser canceladas aqui.</p>
    </>}
    <ModalReautenticacao aberto={confirmando} titulo="Cancelar contratação pendente"
      descricao={`Confirmar cancelamento de ${cliente?.nome || cliente?.email}? A recorrência e todas as faturas pendentes ou vencidas vinculadas serão encerradas. O cliente voltará ao Gratuito.`}
      textoBotao="Confirmar cancelamento" onFechar={() => setConfirmando(false)} onConfirmado={cancelar} />
  </section>;
}
